// Front/src/utils/mathHelper.js

// calculate min and d
export const getRankAndMinFromNandD = (n, d) => {
    if (isNaN(n) || isNaN(d) || n <= 0 || d <= 0) return null;

    let accuracyClass, min;

    if (n > 100000) {
        accuracyClass = 1;
        min = 100 * d;
    } else if (n >= 10000) {
        accuracyClass = 2;
        min = 20 * d;
    } else if (n >= 1000) {
        accuracyClass = 3;
        min = 20 * d;
    } else {
        accuracyClass = 4;
        min = 10 * d;
    }

    return {
        accuracyClass,
        min,
    };
};


const getRoundedValue = (value) => {
    if (value < 100) {
        return Math.round(value + 0.4);
    }

    let multiplyBy;
    if (value < 1000) {
    multiplyBy = 10;
    } else if (value < 10000) {
    multiplyBy = 100;
    } else {
    multiplyBy = 1000;
    }
    
    const can1 = Math.floor(value / multiplyBy) * multiplyBy;
    const can2 = can1 + multiplyBy;
    return Math.abs(value - can1) < Math.abs(value - can2) ? can1 : can2;
};

export const getRecommendedLinearityWeights = ({ min, max, e, accuracyClass }) => {
    if ([min, max, e, accuracyClass].some(v => isNaN(v))) return null;

    let ratio = 1;
    switch (accuracyClass) {
        case 1: ratio = 1000; break;
        case 2: ratio = 100; break;
        case 3: ratio = 10; break;
        case 4: break; // ratio remains 1
        default: break; // ratio remains 1
    }

    const m50 = 50 * ratio * e;
    const m200 = 200 * ratio * e;
    const m50str = `${Math.floor(m50 / e)}e`;
    const m200str = `${Math.floor(m200 / e)}e`;
    const x = max / 3;

    // for debugging
    // console.log("ratio = ", ratio);
    // console.log("e = ", e);
    // console.log("m50 = ", m50);
    // console.log("m200 = ", m200);
    // console.log("m50str = ", m50str);
    // console.log("m200str = ", m200str);
    // console.log("x = ", x);

    const w = {
        linearityWeight1: '0',
        linearityWeight2: min.toString(),
        linearityWeight6: max.toString(),
        linearityNote3: '',
        linearityNote4: '',
        linearityNote5: ''
    };

    const r = (v) => getRoundedValue(v).toString();

    if (m200 >= max) {
        if (m50 >= x && m50 <= 2 * x) {
            w.linearityWeight3 = r(m50 / 2);
            w.linearityWeight4 = r(m50);
            w.linearityNote4 = m50str;
            w.linearityWeight5 = r((m50 + max) / 2);
        } else if (m50 < x) {
            const xtag = (max - m50) / 4;
            w.linearityWeight3 = r(m50);
            w.linearityNote3 = m50str;
            w.linearityWeight4 = r(m50 + xtag);
            w.linearityWeight5 = r(m50 + 2 * xtag);
        } else {
            const xtag = (max - m50) / 4;
            w.linearityWeight3 = r(m50 - 2 * xtag);
            w.linearityWeight4 = r(m50 - xtag);
            w.linearityWeight5 = r(m50);
            w.linearityNote5 = m50str;
        }
    } else if (m200 < 2 * x) {
        w.linearityWeight3 = r(m50);
        w.linearityNote3 = m50str;
        w.linearityWeight4 = r(m200);
        w.linearityNote4 = m200str;
        w.linearityWeight5 = r((m200 + max) / 2);
    } else {
        w.linearityWeight3 = r(m50);
        w.linearityNote3 = m50str;
        w.linearityWeight4 = r((m200 + m50) / 2);
        w.linearityWeight5 = r(m200);
        w.linearityNote5 = m200str;
    }    

    return w;
};

export const getRecommendedTareWeights = ({ max }) => {
    const parsedMax = parseFloat(max);
    if (isNaN(parsedMax)) return null;

    const tareWeight = getRoundedValue(parsedMax / 2);
    return {
        weightValue: tareWeight.toString()
    };
};

export const getRecommendedCornerWeight = ({ max }) => {
    const parsedMax = parseFloat(max);
    if (isNaN(parsedMax)) return null;

    const cornerWeight = getRoundedValue(parsedMax / 3);
    return {
        cornerWeightValue: cornerWeight.toString()
    };
};
